/**
 * カウントダウンが残っているかどうかを返す
 * @param {string | null | undefined} countDown "DD:HH:MM:SS" 形式、または null/undefined（未スタンプ）
 * @returns {boolean}
 */
export const checkIsCountDownActive = (countDown) => {
  return (
    countDown != null &&
    /^\d{2}:\d{2}:\d{2}:\d{2}$/.test(countDown) &&
    countDown !== "00:00:00:00"
  );
};
